import { Card, CardTitle, Skeleton } from '@reveni-io/reveni-ui'

import BillingTransactionsTableSkeleton from '../BillingTransactionsTableSkeleton/BillingTransactionsTableSkeleton'
import * as Styles from './styles'

const BillingDetailPageSkeleton = () => (
  <Styles.Container>
    <Styles.HeaderContainer>
      <Skeleton variant="rounded" width={140} height={20} />
      <Styles.HeaderContent>
        <Styles.InfoContainer>
          <Skeleton variant="text" width={120} height={28} />
          <Skeleton variant="rounded" width={90} height={24} />
        </Styles.InfoContainer>
        <Styles.ActionsContainer>
          <Skeleton variant="rounded" width={90} height={35} />
          <Skeleton variant="rounded" width={90} height={35} />
        </Styles.ActionsContainer>
      </Styles.HeaderContent>
    </Styles.HeaderContainer>

    <Styles.BillingItemContainer>
      <Styles.BillingItemGroup>
        <Skeleton variant="circular" width={24} height={24} />
        <Skeleton variant="text" width={100} height={20} />
        <Skeleton variant="text" width={140} height={20} />
      </Styles.BillingItemGroup>
      <Styles.BillingItemGroup>
        <Skeleton variant="text" width={100} height={20} />
        <Skeleton variant="circular" width={24} height={24} />
        <Skeleton variant="text" width={80} height={20} />
      </Styles.BillingItemGroup>
      <Skeleton variant="rounded" width={90} height={24} />
    </Styles.BillingItemContainer>

    <Styles.TransactionsContainer>
      <Card showBorder={false}>
        <CardTitle>
          <Skeleton variant="text" width={120} height={24} />
        </CardTitle>
        <BillingTransactionsTableSkeleton />
        <Styles.PaginationContainer>
          <Skeleton variant="circular" width={24} height={24} />
          <Skeleton variant="text" width={100} height={16} />
          <Skeleton variant="circular" width={24} height={24} />
        </Styles.PaginationContainer>
      </Card>
    </Styles.TransactionsContainer>
  </Styles.Container>
)

export default BillingDetailPageSkeleton
